import { Injectable, inject } from "@angular/core";
import { MarkerService } from "./marker.service";
import { Coordinate } from "../contract/Address/Coordinates";
import { CompareObject } from "../contract/AVM/CompareObject/CompareObject";
import { CompareType } from "../contract/Enum/CompareObject";
import { EPSGType } from "../contract/Enum/EPSG";
import { createBaseLayerProperties, createCompareableMarkerProperties, getMapLayerByCompareType } from "../helpers/layer-helper";
import { getCompareableMarker } from "../consts/marker-configs";
import { MarkerConfig } from "../contract/Map/MarkerConfig";
import { Address } from "../contract/Address/Address";
import { COMPAREABLE_Z_INDEX } from "../consts/marker-z-index";
import { getCompareObjectsByCompareType } from "../helpers/compareable-helper";
import { PriceInformation } from "../contract/AVM/PriceInformation";
import { MapLayerService } from "./map-layer.service";

@Injectable({
  providedIn: "root"
})
export class CompareableMarkerService {
  private readonly markerService = inject(MarkerService);
  private readonly mapLayerService = inject(MapLayerService);

  setCompareableMarkerForCompareType(priceInformation: PriceInformation, address: Address, isRent: boolean, compareType: CompareType) {
    const compareObjects = getCompareObjectsByCompareType(priceInformation, isRent, compareType);
    if (!compareObjects) {
      return;
    }

    const mapLayer = getMapLayerByCompareType(isRent, compareType);
    if (!mapLayer) {
      return;
    }

    const activeCompareablesMarkers = this.createCompareablesMarkers(compareObjects.filter(e => e.Enabled));
    this.mapLayerService.removeLayerByType(mapLayer);

    let layer = this.mapLayerService.getLayer(mapLayer);
    if (!layer) {
      const markerProperties = createBaseLayerProperties(mapLayer, mapLayer.toString());
      layer = this.mapLayerService.createLayer(mapLayer, COMPAREABLE_Z_INDEX, markerProperties);
    }

    this.markerService.setCircleMarkersOnLayer(layer, activeCompareablesMarkers);
  }

  private createCompareablesMarkers(compareObjects: CompareObject[]): MarkerConfig[] {
    const marker: MarkerConfig[] = [];

    compareObjects.forEach(compareObject => {
      if (compareObject.PositionsInformation.Radius === null) {
        return;
      }

      const coordinate = new Coordinate(
        [compareObject.Address.Coordinate.Longitude, compareObject.Address.Coordinate.Latitude],
        EPSGType.LonLat
      );

      const compareObjectProperties = createCompareableMarkerProperties(compareObject);
      const markerConfig = getCompareableMarker(coordinate, compareObject, compareObjectProperties);

      marker.push(markerConfig);
    });

    return marker;
  }
}
